//import React from "react";
import MDCVisualIcon from "../assets/mdcvisual.webp";

const MDCVisual = () => {
  const url = "https://mdcvisual.com.ar/";

  // Al hacer clic, abre la URL en nueva pestaña de forma segura
  const handleClick = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="button-styles hover-text"
      aria-label="MDCVisual"
    >
      <span className="tooltip-text-web fade">
        Web Site
      </span>
      <img
        src={MDCVisualIcon}
        alt="Logo MDCVisual"
        style={{ width: "120px", height: "auto", objectFit: "cover" }}
      />
    </button>
  );
};

export default MDCVisual;
